import { format, FormatOptions, LocalizeFn } from 'date-fns';

import { useLocale } from './use-locale.hook';

export const useFormat = (ordinalNumber?: LocalizeFn<number>) => {
  const { dateFnsLocale } = useLocale();
  return {
    format: (
      date: Date | null | number | string | undefined | unknown,
      formatStr = 'dd/MM/yyyy',
      options?: Except<FormatOptions, 'locale'>,
    ) => {
      if (!date) return '';
      if (typeof date !== 'string' && !(date instanceof Date) && typeof date !== 'number')
        return '';

      return format(date, formatStr, {
        ...options,
        locale: {
          ...dateFnsLocale,
          localize: {
            ...dateFnsLocale.localize,
            ordinalNumber: ordinalNumber ?? dateFnsLocale.localize.ordinalNumber,
          },
        },
      });
    },
  };
};
